// Phase 4 (api-phase4.md "Guard tours"): a guard tour finding is an ordinary alarm with source `guard_tour` and flag
// `guard_tour`. AlarmSummary carries the flag (not `source`), so the flag is what marks it in the console.

import { Icon } from '../components/Icon.tsx';

export function isGuardTour(a: { flags?: string[] | null; source?: unknown }): boolean {
  return a.source === 'guard_tour' || (a.flags ?? []).includes('guard_tour');
}

/** The "GUARD TOUR" tag on alarm chips and the alarm list (the AI's vision found it, so violet). */
export function GuardTourTag() {
  return (
    <span className="gttag" title="Found by a scheduled guard tour (the vision worker walked the site's cameras)">
      <Icon name="route" />
      guard tour
    </span>
  );
}
